import { useState } from "react";
import "./App.css";

const projects = [
  {
    emoji: "",
    name: "Clanka",
    sub: "An AI robot friend",
    desc: "Custom chassis, stepper motors, Arduino firmware, Raspberry Pi brain, Mistral AI, and persistent memory. I did the torque calculations by hand.",
    tags: ["Arduino", "Raspberry Pi", "Flask", "Mistral AI", "PostgreSQL", "C++", "Vite"],
    live: "https://clanka-eight.vercel.app",
    code: "https://github.com/daniel-c-silva/Clanka",
  },
  {
    emoji: "",
    name: "SynthPons",
    sub: "Webapp that lets you play music in real time",
    desc: "Type chords or notes, get real time audio. The sound is generated from physics — sine waves built with NumPy. Flask to serve the WAV, React plays the WAV.",
    tags: ["React", "Flask", "NumPy", "Audio synthesis"],
    live: "https://synth-bridge.vercel.app",
    code: "https://github.com/daniel-c-silva/SynthBridge",
  },
  {
    emoji: "",
    name: "Portugal AQI",
    sub: "What you are breathing",
    desc: "Real-time air quality for 12 Portuguese cities on an actual map of Portugal. Mistral AI writes a line about each city. Flask caches everything so it doesn't hammer the APIs.",
    tags: ["React", "Flask", "Mistral AI", "Real-time data"],
    live: "https://portugal-aqi.vercel.app",
    code: "https://github.com/daniel-c-silva/PortugalAQI",
  },
  {
    emoji: "",
    name: "Geographica",
    sub: "for country data",
    desc: "Search any country, compare two side by side, save your favourites to a database. I taught myself SQLite in 13 days to build this.",
    tags: ["React", "Flask", "SQLite", "REST Countries API"],
    live: "https://geographica-brown.vercel.app",
    code: "https://github.com/daniel-c-silva/Geographica",
  },
  {
    emoji: "",
    name: "Plume",
    sub: "App to answer questions with friends",
    desc: "App allows friends to answer daily questions together and keep an archive of their answers",
    tags: ["Vite", "Flask", "Ollama", "postgreSQL"],
    live: null,
    code: "https://github.com/daniel-c-silva/Plume",
  },
  {
    emoji: "",
    name: "Job Dashboard",
    sub: "Track your applications",
    desc: "Add companies, stacks, dates and statuses. Delete them, update them. Built with PostgreSQL — I upgraded from SQLite myself just to learn it.",
    tags: ["React", "Flask", "PostgreSQL"],
    live: null,
    code: "https://github.com/daniel-c-silva/JobApplication-Dashboard",
  },
];

export default function App() {
  return (
    <div className="page">

      {/* NAV */}
      <nav className="nav">
        <a href="#top" className="nav-logo">ds.</a>
        <div className="nav-links">
          <a href="#about" className="nav-link">about</a>
          <a href="#projects" className="nav-link">projects</a>
          <a href="#contact" className="nav-link">contact</a>
        </div>
      </nav>

      {/* HERO */}
      <section id="top" className="hero">
        <p className="hero-greeting">hey, I'm</p>
        <h1 className="hero-name">Daniel Silva</h1>
        <p className="hero-role">full-stack developer · Porto, Portugal</p>
        <p className="hero-desc">
          I build things <br />
        </p>
        <div className="hero-btns">
          <a href="#projects" className="btn-solid">see my work</a>
          <a href="https://github.com/daniel-c-silva" target="_blank" rel="noreferrer" className="btn-outline">github</a>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="section">
        <h2 className="section-title">about me</h2>
        <div className="card">
          <p className="body-text">
            I'm 19, from Porto, and I've been building things for awhile — . I'm self-taught and every project I ship is something I actually wanted to exist, something I wanted to use.
          </p>
          <p className="body-text">
            I speak Portuguese, French, English, and Spanish. Finished my Baccalauréat in France, and I'm now an <strong className="gold-text">E42 Student</strong>.
          </p>
          <p className="body-text">
            My goal is to learn while creating.
          </p>
          <div className="chips">
            {["Python", "JavaScript", "C++", "C#", "Flask", "Vite", "React", "PostgreSQL", "SQLite", "NumPy", "Mistral AI", "OpenAI", "Arduino", "Raspberry Pi", "Git"].map(t => (
              <span key={t} className="chip">{t}</span>
            ))}
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <section id="projects" className="section">
        <h2 className="section-title">things I've built</h2>
        <p className="section-sub">every project is original.</p>
        <div className="grid">
          {projects.map(p => (
            <div key={p.name} className="project-card">
              {p.emoji && <div className="card-emoji">{p.emoji}</div>}
              <h3 className="card-name">{p.name}</h3>
              <p className="card-sub">{p.sub}</p>
              <p className="card-desc">{p.desc}</p>
              <div className="card-tags">
                {p.tags.map(t => <span key={t} className="card-tag">{t}</span>)}
              </div>
              <div className="card-links">
                {p.live && (
                  <a href={p.live} target="_blank" rel="noreferrer" className="link-solid">view live</a>
                )}
                <a href={p.code} target="_blank" rel="noreferrer" className="link-ghost">code</a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="section">
        <h2 className="section-title">get in touch</h2>
        <div className="card">
          <p className="body-text">
            have a question or want to work together? let's talk.
          </p>
          <div className="contact-links">
            <a href="mailto:rui.d.carvalhosilva@gmail.com" className="contact-link">rui.d.carvalhosilva@gmail.com</a>
            <a href="https://www.linkedin.com/in/daniel-silva-8177a937b/" target="_blank" rel="noreferrer" className="contact-link">linkedin</a>
            <a href="https://github.com/daniel-c-silva" target="_blank" rel="noreferrer" className="contact-link">github</a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        © Daniel Silva · Porto, Portugal · 2026
      </footer>

    </div>
  );
}
